import './polyfills'; // must run before any algosdk/use-wallet code (Buffer/process globals)
import React from 'react';
import ReactDOM from 'react-dom/client';
import { WalletProvider } from '@txnlab/use-wallet-react';
import { WalletUIProvider } from '@txnlab/use-wallet-ui-react';
import '@txnlab/use-wallet-ui-react/dist/style.css';
import './wallet-ui-theme.css';
import './css.css';
import App from './App';
import { walletManager } from './wallet/walletManager';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <WalletProvider manager={walletManager}>
    <WalletUIProvider theme="dark">
      <App />
    </WalletUIProvider>
  </WalletProvider>
);
